/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import React, { FC, useEffect, useState } from "react";
import { useHistory, useRouteMatch } from "react-router-dom";

import { withProcedureWraper } from "..";
import { Routes } from "../../../AppRoutes";
import { Box } from "../../../components/box";
import { InputArrayData, InputSelect, InputTextArea } from "../../../components/input";
import { Button } from "../../../modules/button";
import { InputWraper, useForm } from "../../../modules/form";
import { useSelector } from "../../../store/store";
import { InputSelectTag } from "../../../components/input/select-tag";
import { ItCodeContentStructure, ItCodeContentForm } from "./itCodeContentForm";
import { CreateNotification } from "../../../components/notifier";
import { Icon } from "../../../components/icon";
import { ITCodeRequestService } from "../../../services/it-code-request/itCodeRequest.service";
import { MailService } from "../../../services/mail/mail.service";
import { itCodeRequestTypes } from "../../../constants/itCodeRequestConstants";
import { UserSelect } from "../../../components/input/select/UserSelect";

import { getEnv } from "../../../AppConfigs";
import { mailRegexs } from "../../../constants/mailTemplateConstants";
import { requestStatus } from "../../../constants/statusConstants";

const siteUrl = getEnv("REACT_APP_APPROVER_IT_CODE_REQUESTS_URL");

export const ITCodeGrantedCreatePage: FC = withProcedureWraper(() => {
  const history = useHistory();
  const { id } = useRouteMatch().params as any;
  const employees = useSelector((state: any) => state.employee.employees);
  const softwares = useSelector((state: any) => state.systemMgmt.softwares);
  const mailtemplates = useSelector((state: any) => state.systemMgmt.mailtemplates);
  const user = useSelector((state: any) => state.user);
  const currentUserName = user?.current?.username;
  const [approverOptions, setApproverOptions] = useState([]);
  const [approver, setApprover] = useState("");
  const [requestType, setRequestType] = useState(itCodeRequestTypes[0].value);
  const [userDepartment, setUserDepartment] = useState(null as any);
  const [softwareSelected, setSoftwareSelected] = useState(null as any);
  const { getInputProps, handleSubmit, isSubmitting, setValues } = useForm({
    structure: [
      {
        name: "description",
        label: "Mô tả",
      },
      {
        name: "approver",
        label: "Người duyệt",
      },
      {
        name: "application",
        label: "Phần mềm",
      },
      {
        name: "type",
        label: "Yêu cầu",
      },
      {
        name: "requests",
        label: "Nội dung",
        defaultValue: [],
      },
    ],
    onSubmit: async (payload) => {
      const { description, requests } = payload;
      const approverTmp = employees.find((f: any) => f.eMail === approver);
      const software: any = softwares.find((f: any) => f.id === softwareSelected);
      const requestTypeText: any = itCodeRequestTypes.find((f: any) => f.value === requestType)?.label;
      const assignees = software.eITStaff.split(";");
      const itCodeRequest: any = {
        fields: {
          Title: `${requestTypeText} - ${software.Title}`,
          eApprovedBy: approverTmp ? `${approverTmp.eMail}|${approverTmp.Title}` : null,
          eSoftwareId: software.id,
          eApprovedByITLead: `${software.eITTeamLead}|${software.eTeamLeadName}`,
          eApprovedByITHead: `${software.eITHead}|${software.eITHeadName}`,
          eAssignee: `${assignees[0]}`,
          eRequestStatus: requestStatus.submitted,
          eDescription: description,
          eRequestType: requestType,
          eContent: JSON.stringify(requests),
        },
      };
      addITCodeRequest(itCodeRequest);
    },
  });

  const sendMail = async (approver: any, record: any) => {
    const arr = approver.split("|");
    const tomail = arr.length > 0 ? arr[0] : "";
    const name = arr.length > 1 ? arr[1] : "";
    const template = mailtemplates.find((m: any) => m.eMailType === "ITCRA");
    const content = template.eContent.replace(mailRegexs.zero, name).replace(mailRegexs.siteUrl, siteUrl)
      .replace(mailRegexs.nine + ";", record.id)
      .replace(mailRegexs.ten + ";", record.fields.eDescription ?? "");
    const subject = template.eSubject;
    const message = MailService.buildMailMesssage(subject, content, "html", tomail);
    await MailService.sendMail(message);
  };

  const addITCodeRequest = (itCodeRequest: any) => {
    if (id != 0) {
      ITCodeRequestService.updateITCodeRequest(id, itCodeRequest.fields).then(
        (res) => {
          CreateNotification({
            title: "Thành công",
            body: `Chỉnh sửa yêu cầu thành công.`,
            icon: "/icons/success.png",
          });
          history.push(Routes.procedureItCodeGranted.path.replace(":id", id));
        },
        (error) => {
          CreateNotification({ title: "Thất bại", body: `Chỉnh sửa yêu cầu thất bại.`, icon: "/icons/error.png" });
          console.log(error);
        },
      );
    } else {
      ITCodeRequestService.addITCodeRequest(itCodeRequest).then(
        (res) => {
          CreateNotification({ title: "Thành công", body: `Tạo yêu cầu thành công.`, icon: "/icons/success.png" });
          if (itCodeRequest.fields.eApprovedBy) {
            sendMail(itCodeRequest.fields.eApprovedBy, itCodeRequest);
          }
          history.push(Routes.procedureItCodeGranted.path);
        },
        (error) => {
          CreateNotification({ title: "Thất bại", body: `Tạo yêu cầu thất bại.`, icon: "/icons/error.png" });
          console.log(error);
        },
      );
    }
  };

  const onSoftwareChange = (selectedOptions: any) => {
    setSoftwareSelected(selectedOptions ? selectedOptions.value : "");
  };

  const onApproverChange = (selectedOptions: any) => {
    setApprover(selectedOptions ? selectedOptions.value : "");
  };

  const checkUserDepartment = () => {
    const userDepartment = employees.find((o: any) => o.eMail?.toLowerCase() === currentUserName?.toLowerCase());
    setUserDepartment(userDepartment);
  };

  const getApproverOptions = () => {
    let approverTitleCode = "TP,PP";
    const approvers = employees
      .filter(
        (f: any) => approverTitleCode.indexOf(f.eBizTitleCode) > -1 && f.eDepartment === userDepartment.eDepartment,
      )
      .map((o: any) => ({ label: o.Title, value: o.eMail, default: o.eDefault || false }));
    setApproverOptions(approvers);
    const defaultApprover = approvers.find((a: any) => a.default);
    setApprover(defaultApprover.value || approvers[0].value);
  };

  const onTypeChange = (selectedOptions: any) => {
    setRequestType(selectedOptions);
  };

  useEffect(() => {
    if (id != 0) {
      ITCodeRequestService.getITCodeRequest(id)
        .then((res) => {
          const { eDescription, eApprovedBy, eSoftwareId, eRequestType, eContent } = res.fields;
          const approverEmail = eApprovedBy.split("|")[0];
          setValues({ description: eDescription, requests: JSON.parse(eContent) });
          setApprover(approverEmail);
          setSoftwareSelected(eSoftwareId);
          setRequestType(eRequestType);
        })
        .catch((error) => console.log(error));
    } else {
      setApprover(employees[0]?.eMail);
    }
  }, [id]);

  useEffect(() => {
    if (employees && employees.length > 0) {
      checkUserDepartment();
    }
  }, [employees]);

  useEffect(() => {
    if (userDepartment) {
      getApproverOptions();
    }
  }, [userDepartment]);

  return (
    <div className="ITCodeGrantedCreateNewPage">
      <div className="pd15">
        <div className="PageHead">
          <div className="title">
            <div className="btnBack" onClick={() => history.push(Routes.procedureItCodeGranted.path)}>
              <Icon.ArrowLeft />
            </div>
            {"Tạo yêu cầu"}
          </div>
        </div>

        <Box title="Thông tin">
          <form onSubmit={handleSubmit}>
            <InputWraper
              inputProps={getInputProps("type")}
              renderInput={(s) => (
                <InputSelectTag {...s} options={itCodeRequestTypes} value={requestType} onChange={onTypeChange} />
              )}
            />
            <InputWraper
              inputProps={getInputProps("application")}
              renderInput={(s) => (
                <InputSelect
                  {...s}
                  options={softwares.map((o: any) => ({ label: o.Title, value: o.id }))}
                  value={softwareSelected}
                  onChange={onSoftwareChange}
                  placeholder="Chọn phầm mềm"
                />
              )}
            />
            <InputWraper inputProps={getInputProps("description")} component={InputTextArea} />

            <InputWraper
              inputProps={getInputProps("requests")}
              renderInput={(state) => (
                <InputArrayData {...state} form={ItCodeContentForm} structure={ItCodeContentStructure} />
              )}
            />
            <InputWraper
              inputProps={getInputProps("approver")}
              renderInput={(s) => (
                <UserSelect
                  {...s}
                  placeholder="Chọn người duyệt"
                  options={approverOptions}
                  value={approver}
                  onChange={onApproverChange}
                />
              )}
            />
            <div className="textRight">
              <Button type="submit" label="Xác nhận" isLoading={isSubmitting} />
              <Button
                type="button"
                label="Huỷ"
                buttonType="grey-outline"
                className="ml10"
                onClick={() => history.push(Routes.procedureItCodeGranted.path)}
              />
            </div>
          </form>
        </Box>
      </div>
    </div>
  );
});
